import { DSTLogo } from "@/components/dst-logo";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export const Maintenance = () => (
  <>
    <header className="bg-primary">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-6">
        <a href="https://dst.com.bn">
          <DSTLogo className="h-10" variant="white" />
        </a>
      </div>
    </header>

    <AlertDialog open={true}>
      <AlertDialogContent className="!max-w-sm gap-6">
        <AlertDialogHeader className="gap-6 sm:text-center">
          <AlertDialogTitle>We'll be right back!</AlertDialogTitle>
          <p>Sorry, we are currently undergoing maintenance.</p>
          <p>
            In the meantime, you can still submit your interest in our product
            using the link below.
          </p>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center">
          <a
            className="mx-auto"
            href="https://www.dst.com.bn/submit-your-interest"
          >
            <Button className="text-primary" variant="ghost">
              www.dst.com.bn/submit-your-interest
            </Button>
          </a>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </>
);
